import { Reducer } from 'redux'
import { CommonApplicationState, CommonApplicationActionTypes } from './types'
import { translateCountries } from '../../utils/translate';
import { TrackingProvider } from '../../tracking/trackingProvider';

const initialState: CommonApplicationState = {
	countries: [],
	families: [],
	infotainments: [],
	errors: undefined,
	importerSettings: null,
	trackingProvider: new TrackingProvider()
}

const reducer: Reducer<CommonApplicationState> = (state = initialState, action) => {
	switch (action.type) {

		case CommonApplicationActionTypes.FETCH_SUCCESS_Models: {
			return { ...state, families: action.payload }
		}
		case CommonApplicationActionTypes.FETCH_SUCCESS_Infotaiments: {
			return { ...state, infotainments: action.payload }
		}
		case CommonApplicationActionTypes.FETCH_SUCCESS_Countries: {
			return { ...state, countries: translateCountries(action.payload) }
		}
		case CommonApplicationActionTypes.FETCH_SUCCESS_ImporterSettings: {
			return { ...state, importerSettings: action.payload }
		}
		default: {
			return state;
		}
	}
}

export { reducer as commonApplicationReducer }